import React from 'react'

interface CompanyListSkeletonProps {
  count?: number
}

export const CompanyListSkeleton: React.FC<CompanyListSkeletonProps> = ({
  count = 4,
}) => {
  const baseId = React.useId()

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`${baseId}-${index}`}
          className="flex items-center w-full gap-3 p-3 bg-white border rounded-lg border-gray-light-200"
        >
          <div className="w-5 h-5 rounded bg-gray-light-200 animate-pulse" />
          <div className="flex items-center flex-1 gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-light-200 animate-pulse" />
            <div className="w-32 h-5 rounded bg-gray-light-200 animate-pulse" />
          </div>
        </div>
      ))}
    </>
  )
}
